export default __webpack_public_path__ + "static/media/logo-dark-bg.09d25400.svg";